module.exports = __webpack_public_path__ + "img/accueil-salle amanger.f15011e2.jpg";